'use strict';

var _ = require('lodash');
var d3 = require('d3');
var RomSummaryOpportunityTrendsChart = function RomSummaryOpportunityTrendsChart(AbstractChart, chartGroups, chartXAxis, chartYAxis, chartTiles, chartBrush, chartConstants, chartCurve, chartSimpleBars, d3Helper, chartCircles, $timeout) {
  var chartParamsBuilder = require('./RomSummaryOpportunityTrendsParams');
  var chartScales = require('./RomSummaryOpportunityTrendsScales');
  var Chart = function Chart(container, formatters, config) {
    var initialDataLength;
    AbstractChart.call(this, container);
    // chart components
    var groups = chartGroups('dimension', formatters && formatters.tooltipFormatter, true);
    var brush, updateBrushSelection, maxSelectedWeeks;
    var tiles = chartTiles('any', 'value', 'tiles').withHeight(2);
    var curve = chartCurve('dimension', 'revOpp').discontinuous(true);
    var recaptureBar = chartSimpleBars('recapture');
    var spillBar = chartSimpleBars('spill');
    var circles = chartCircles('circles', 2);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    if (config && config.xAxisSkew) {
      xAxis.withTextRotation(chartConstants.AXIS.SKEW.DEG_30);
    }
    var xYearAxis = !formatters.xYearAxisTickFormatter ? false : chartXAxis(formatters.xYearAxisTickFormatter);
    var xAxisLabel = '';
    if (config && config.xAxisLabel) {
      xAxisLabel = config.xAxisLabel;
    }
    d3Helper.createGroupElement(this.dataGroup, 'x-axis-label').append('text').text(xAxisLabel);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).label('Rev. Opp');
    var yAxisRight = chartYAxis(formatters.yRightAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT).withoutHorizontalLines().label('Rev. Opp. %').withLabelRotation(-90);
    var dispatch = d3.dispatch('rangechangeend', 'rangechange');
    d3.rebind(this, dispatch, 'on');
    if (config && config.brush) {
      brush = chartBrush();
      updateBrushSelection = function updateBrushSelection(range) {
        var selection = brush.getSelection();
        var selectionSize = selection[0][1] - selection[0][0];
        if (selectionSize === 0) {
          brush.setSelection(range);
        } else {
          _.forEach(selection, function (s) {
            brush.updateBrush(s);
          });
        }
      };
      groups.on('groupclick', function (d, i) {
        brush.setSelection([i, i + 1]);
        dispatch.rangechangeend(brush.getSelection());
      });
      brush.on('brushend', function (range) {
        dispatch.rangechangeend(range);
      });
      brush.on('brushchange', function (range, triggerEnd) {
        this.brushChangeAction(range, groups);
        dispatch.rangechange(brush.getSelection());
        if (triggerEnd) {
          dispatch.rangechangeend(brush.getSelection());
        }
      }.bind(this));
    }
    function calculateXYearAxisValue(values) {
      var result = [];
      for (var i = 0; i < values.length; i++) {
        var value = values[i];
        if (value && value.month() >= 6) {
          result.push(value);
          i += 52 - value.week() + 26;
        }
      }
      var lastValue = values[values.length - 1];
      if (lastValue && lastValue.month() < 6) {
        result.push(lastValue);
      }
      if (result.length === 1) {
        result = [values[Math.round(values.length / 2) - 1]];
      }
      return result;
    }
    function calculateMaxBrushRange(range) {
      if (maxSelectedWeeks && range && range[1] - range[0] > maxSelectedWeeks) {
        return [Math.max(0, range[1] - maxSelectedWeeks), range[1]];
      } else {
        return range;
      }
    }
    this.render = function (data, range) {
      var chartParams = chartParamsBuilder(data, config && config.forceWidth);
      this.initChart(data, range, chartParams);
      initialDataLength = initialDataLength || data.length;
      this.scales = chartScales(this.params, this.data, range);
      var ticks = this.scales.yScale.ticks();
      var yLeftAxisValues = ticks.length > 0 ? [ticks[0], 0, ticks[ticks.length - 1]] : [];
      yAxisLeft.withTickValues(yLeftAxisValues);
      ticks = this.scales.yScaleRight.ticks();
      var yRightAxisValues;
      if (ticks.length === 0) {
        yRightAxisValues = [];
      } else {
        yRightAxisValues = [ticks[0], 0, ticks[ticks.length - 1]];
      }
      yAxisRight.withTickValues(yRightAxisValues);
      this.callForDataGroup([yAxisLeft, groups, recaptureBar, spillBar, tiles, xAxis], this.scales);
      this.callForDataGroup([curve, circles], {
        xScale: this.scales.xScale,
        yScale: this.scales.yScaleRight
      });
      if (xYearAxis !== false) {
        var xYearAxisValues = calculateXYearAxisValue(this.scales.xScale.domain());
        d3Helper.createGroupElement(this.dataGroup, 'x-axis-year').attr('transform', 'translate(0,30)').call(xYearAxis.withTickValues(xYearAxisValues).params(this.params).scales(this.scales));
      }
      d3Helper.createGroupElement(this.dataGroup, 'x-axis-label').attr('transform', 'translate(' + -this.params.padding.left + ',' + (this.params.height + 20) + ')');
      if (config && config.brush) {
        this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
        var maxBrushRange = calculateMaxBrushRange(range);
        if (!maxBrushRange || !_.isEqual(range, maxBrushRange)) {
          updateBrushSelection(maxBrushRange || this.scales.xScale.domain().length);
        }
      }

      //due to brush right hand was over right axis, axis was moved to post-data-group
      this.callForPostDataGroup([yAxisRight.params(this.params)], {
        xScale: this.scales.xScale,
        yScale: this.scales.yScaleRight
      });
    };
    this.expandBrush = function () {
      var domainLength = initialDataLength;
      if (maxSelectedWeeks && domainLength) {
        brush.setSelection([Math.max(0, domainLength - maxSelectedWeeks), domainLength]);
      } else if (domainLength || this.data && this.data.length) {
        brush.setSelection([0, domainLength || this.data.length]);
      }
    };
    this.resetBrushSelection = function () {
      this.expandBrush();
      $timeout(function () {
        dispatch.rangechangeend(brush.getSelection());
      });
    };
    this.resetInitialDataLength = function () {
      initialDataLength = null;
    };
    this.clearBrush = function () {
      brush.getModel().clearRanges();
      brush.clear();
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.withMaxSelectedWeeks = function (value) {
      maxSelectedWeeks = value;
      return this;
    };
    this.getBrush = function () {
      return brush;
    };
    this.setInitialSelection = function (range) {
      if (_.find(brush.getSelection(), range)) {
        return;
      }
      brush.setSelection(range, true);
    };
    container.on('$destroy', function () {
      dispatch.on('rangechangeend', null);
      dispatch.on('rangechange', null);
      if (config && config.brush) {
        groups.on('groupclick', null);
        brush.on('brushchange', null);
        brush.on('brushend', null);
      }
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
RomSummaryOpportunityTrendsChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsTiles', 'ChartElementsMultiBrush', 'ChartElementsConstants', 'ChartElementsCurves', 'ChartElementsSimpleBars', 'd3Helper', 'ChartElementsCircles', '$timeout'];
module.exports = RomSummaryOpportunityTrendsChart;